/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_8f40ed70{display:inline-block;vertical-align:middle;speak:none;width:1em;height:1em}.svg_8f40ed70{height:100%;fill:currentColor;vertical-align:top}"}]);
export const root = "root_8f40ed70";
export const svg = "svg_8f40ed70";